const moduleNameKey = "scaleInput";

export const scaleInputEn = {
  [moduleNameKey]: {
    scaleLabel: "Scale factor",
    scalePlaceholder: "1",
  },
};

export const scaleInputPtBr = {
  [moduleNameKey]: {
    scaleLabel: "Fator de escala",
    scalePlaceholder: "1",
  },
};

export const scaleInputDe = {
  [moduleNameKey]: {
    scaleLabel: "Skalierungsfaktor",
    scalePlaceholder: "1",
  },
};

export const scaleInputZhHans = {
  [moduleNameKey]: {
    scaleLabel: "缩放系数",
    scalePlaceholder: "1",
  },
};

export const scaleInputIt = {
  [moduleNameKey]: {
    scaleLabel: "Fattore di scala",
    scalePlaceholder: "1",
  },
};

export const scaleInputEs = {
  [moduleNameKey]: {
    scaleLabel: "Factor de escala",
    scalePlaceholder: "1",
  },
};

export const scaleInputNl = {
  [moduleNameKey]: {
    scaleLabel: "Schaalfactor",
    scalePlaceholder: "1",
  },
};

export const scaleInputTr = {
  [moduleNameKey]: {
    scaleLabel: "Ölçek faktörü",
    scalePlaceholder: "1",
  },
};
